<template>
  <PTransparentLoader :loading="loading" class="event-wizard">
    <CContainer class="p-0" style="max-width: 1440px">
      <div v-if="!loading">
        <div class="d-flex align-items-center">
          <h1 class="main-header mb-1" v-translate translate-context="event_wizard.overview">Overview</h1>
          <CButton @click="startTour" class="ml-2 p-0" size="sm" style="color: #a9a8c2"
                   v-if="hasPerm('feature.overview_tour')">
            <CIcon name="cipCircleHelp" style="vertical-align: baseline"/>
          </CButton>
        </div>

        <p v-translate translate-context="event_wizard.overview">Event overview: key data, actions and notes</p>
        <template v-if="isDraft">
          Publish your event to see the overview
        </template>
        <template v-else>
          <Stats/>
          <CRow>
            <GalleriesUpload/>
            <Tools :step="step_overview" />
            <GalleriesPricelist/>
            <CCol xl="6" class="mb-3" v-if="hasPerm('dashboard.view_feature_operation_log')">
              <EventNote/>
            </CCol>
          </CRow>
        </template>
        <PTour ref="tourOverview" :name="tourName" :steps="overviewSteps"/>
      </div>
    </CContainer>
  </PTransparentLoader>
</template>

<script>

import PTransparentLoader from "@/domain/core/components/PTransparentLoader.vue";
import EventNote from "@/domain/eventWizard/components/overview/EventNote.vue";
import {mapActions, mapGetters} from "vuex";
import Stats from "@/domain/eventWizard/components/overview/Stats.vue";
import PTour from "@/domain/tours/components/PTour.vue";
import GalleriesUpload from "@/domain/eventWizard/components/overview/GalleriesUpload.vue";
import {overviewSteps} from "@/domain/tours/tours";
import GalleriesPricelist from "@/domain/eventWizard/components/overview/GalleriesPricelist.vue";
import eventBus from "@/domain/core/constant/eventBus";
import Tools from "@/domain/eventWizard/components/overview/Tools.vue";

export default {
  name: "StepOverview",
  components: {
    Tools,
    GalleriesPricelist,
    GalleriesUpload, PTour, Stats, EventNote, PTransparentLoader
  },
  props: {},
  computed: {
    ...mapGetters('event', [
      'isDraft',
      'picaServiceId',
    ]),
    ...mapGetters('tours', [
      'isTourViewed'
    ]),
    ...mapGetters('eventWizard', [
      'step_overview',
      'isStepLoading'
    ]),
    loading() {
      return this.isStepLoading('overview')
    },
    overviewSteps() {
      return overviewSteps
    },
    tourName() {
      return `event-overview-${this.picaServiceId}`
    }
  },
  async created() {
    this.registerEvent(eventBus.event.published, this.onEventChange)
    await this.onEventChange()
  },
  beforeDestroy() {
    this.unregisterEvent(eventBus.event.published, this.onEventChange)
  },
  async mounted() {
    await this.delay(1000)
    if (!this.isTourViewed(this.tourName) && this.hasPerm('feature.overview_tour'))
      this.startTour()
  },
  methods: {
    ...mapActions('eventWizard', [
      'fetchStepData'
    ]),
    async onEventChange() {
      await this.fetchStepData('overview')
    },
    startTour() {
      this.$refs.tourOverview?.start('0', 1000)
    }
  }
}
</script>
